import React, { useContext, useEffect, useState } from "react";
import classNames from "classnames";
import { useNavigate } from "react-router-dom"; // Import useNavigate from react-router-dom
import styles from "./menu.module.css";
import { UserContext } from "../../context";
import { Tooltip } from "antd";
import * as Icons from "@ant-design/icons";
import { CaretUpOutlined, CaretDownOutlined } from "@ant-design/icons";

type TProps = {
  isOpen?: any;
  sideBarStatus?: boolean;
};

export default function SidebarComponent(props: TProps) {
  const context: any = useContext(UserContext);
  const menuData = context.menuHierarchy;
  const navigate = useNavigate(); // Replaces useRouter from Next.js

  const handleClick = (url: string) => {
    navigate(url); // Use navigate to change routes
  };

  // Make sure to import Tooltip from Ant Design

  const MenuItem = ({ item }: any) => {
    const [isSubMenuVisible, setIsSubMenuVisible] = useState(false);
    const [isActive, setIsActive] = useState(false);

    const toggleSubMenu = () => {
      setIsSubMenuVisible(!isSubMenuVisible);
      if (item.parentId === 0 || (item.children && item.children.length > 0)) {
        setIsActive(!isActive);
      }
    };

    const hasChildren = (item: any) => {
      return item.children && item.children.length > 0;
    };

    const isChildActiveRecursive = (children: any) => {
      return (
        children &&
        children.some((child: any) => {
          if (child.children) {
            return isChildActiveRecursive(child.children);
          }
          return window.location.pathname === child.entityUrl;
        })
      );
    };

    useEffect(() => {
      const isChildActive = isChildActiveRecursive(item.children);
      setIsSubMenuVisible(isChildActive);
      setIsActive(isChildActive || window.location.pathname === item.entityUrl);
    }, [item.children, item.entityUrl, item.parentId]);

    const handleClick = (e: React.MouseEvent) => {
      e.stopPropagation(); // Prevent click propagation
      if (!hasChildren(item)) {
        navigate(item.entityUrl);
      }
    };

    const IconRenderer = ({ iconName }: { iconName: string | undefined }) => {
      const AntIcon: any = Icons[iconName as keyof typeof Icons];
      return AntIcon ? (
        <AntIcon />
      ) : (
        <span className={styles.spanOfInconStyle}>-</span>
      );
    };

    return (
      <div className={classNames(styles.user_menu)}>
        <Tooltip title={item.dispName} placement="right">
          <div
            className={classNames(styles.item, { [styles.active]: isActive })}
            onClick={hasChildren(item) ? toggleSubMenu : handleClick}
          >
            <div className={styles.iconStyle}>
              <span className={styles.spanOfInconStyle}>
                <IconRenderer iconName={item?.iconName || ""} />
              </span>
              <span className={`${styles.menu_name} ${styles.spanDispName}`}>
                {props?.sideBarStatus ? item.dispName : ""}
              </span>
            </div>

            {hasChildren(item) && props.sideBarStatus && (
              <div>
                {isSubMenuVisible ? <CaretUpOutlined /> : <CaretDownOutlined />}
              </div>
            )}
          </div>
          {isSubMenuVisible && hasChildren(item) && (
            <div className={styles.sub_menu}>
              {item.children.map((subItem: any, index: any) => (
                <MenuItem key={index} item={subItem} />
              ))}
            </div>
          )}
        </Tooltip>
      </div>
    );
  };

  return (
    <div>
      <div className={styles.user_sidebar}>
        <div className={styles.user_detail}>
          <div className={styles.user_box}>
            <span className={styles.user_pic_compact}></span>
            {props?.sideBarStatus && (
              <div className={styles.appNameContainer}>
                <span style={{ fontFamily: "Montserrat-SemiBold" }}>IDEX</span>{" "}
                <span
                  style={{
                    color: "var(--bs-primary)",
                    fontFamily: "Montserrat-SemiBold",
                  }}
                >
                  SERVICE
                </span>
              </div>
            )}
          </div>
        </div>
        <div className={styles.menuSection}>
          {menuData &&
            menuData?.map((item: any, index: number) => (
              <MenuItem key={index} item={item} />
            ))}
        </div>
      </div>
    </div>
  );
}
